import { FC, useState, useCallback } from 'react'
import { Show, useRecordContext, useRefresh } from 'react-admin'
import { Box, Grid } from '@mui/material'
import { PrognoseSetResponse } from '../../types/apiRequests'
import { PrognoseShowView } from '../../components/prognose'
import GebiedTreeView from '../../components/prognose/GebiedTreeView'

const GebiedsprognoseShowContent: FC = () => {
  const record = useRecordContext<PrognoseSetResponse>()
  const refresh = useRefresh()
  const [selectedGebied, setSelectedGebied] = useState('')

  const handleGebiedSelect = useCallback((code: string) => {
    setSelectedGebied(code)
  }, [])

  if (!record) return null

  const hasGebiedsindeling = record.status === 'completed' && record.gemeente_sid

  return (
    <Box>
      {hasGebiedsindeling ? (
        <Grid container spacing={2}>
          {/* Treeview sidebar */}
          <Grid item xs={12} md={3}>
            <GebiedTreeView
              gemeenteSid={record.gemeente_sid}
              selectedGebiedCode={selectedGebied}
              onSelectGebied={handleGebiedSelect}
            />
          </Grid>
          {/* Main content */}
          <Grid item xs={12} md={9}>
            <PrognoseShowView
              record={record}
              loading={false}
              subtitle={
                selectedGebied
                  ? `Gebiedsprognose | ${selectedGebied} | Periode: ${record.bjaar} - ${record.ejaar}`
                  : `Gebiedsprognose | Periode: ${record.bjaar} - ${record.ejaar}`
              }
              onRefetch={refresh}
            />
          </Grid>
        </Grid>
      ) : (
        <PrognoseShowView
          record={record}
          loading={false}
          subtitle={`Gebiedsprognose | Periode: ${record.bjaar} - ${record.ejaar}`}
          onRefetch={refresh}
        />
      )}
    </Box>
  )
}

const GebiedsprognoseShow: FC = () => (
  <Show>
    <GebiedsprognoseShowContent />
  </Show>
)

export default GebiedsprognoseShow
